import { render, staticRenderFns } from "./ProductsReports.vue?vue&type=template&id=32e0dc90"
import script from "./ProductsReports.vue?vue&type=script&lang=js"
export * from "./ProductsReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports